import _ from 'lodash'

import API from '@/api'

import utility from '@/mixins/utility'

const state = {

    openApps: [],

    items: [],

    appMenuStatus: false

}

const getters = {

    hasOpenApps: state => ( state.openApps.length > 0 ),

    openApps: state => state.openApps,

    currentApp: state => _.chain(state.openApps).filter({ isVisible:true }).first().value(),

    items: state => state.items,

    appMenuStatus: state => state.appMenuStatus,

    // menu positions.
    apps: state => _.filter(state.items, (item)=>{ return item.position == 'app' }),

    user: state => _.filter(state.items, (item)=>{ return item.position == 'user' }),

    toolbar: state => _.filter(state.items, (item)=>{ return item.position == 'toolbar' }),

}

const actions = {

  fetch({ commit })
  {
    API.menu.list({ include:'children' })
            .then(({ data })=>{
              
              const items = utility.methods.mapModels(data.data, 'menu')

              commit('setItems', items)

            })
  },

  open({ commit }, menuItem)
  {
    commit('openItem', menuItem)
  },

  route({ commit, state }, url)
  {
    const menuItems = state.items.filter((item)=>{
      return url.indexOf(item.domain) >= 0
    })

    if(!menuItems.length)
      return
    
    const menuItem = menuItems.shift()
          menuItem.setUrl(url)

    commit('openItem', menuItem)
  },

  showAppMenu({ commit }, status=true)
  {
    commit('setAppMenuStatus', status)
  },

  toggleAppMenu({ commit })
  {
    commit('toggleAppMenuStatus')
  },

}

const mutations = {

    openItem(state, menuItem)
    {
      // check if item opens outside hub
      if( menuItem.blank )
        return window.open(menuItem.url)

      // check if item is not open...
      if( !_.find(state.openApps, { id:menuItem.id }) )
      {
        state.openApps.push(menuItem)

        menuItem.open()
      }

      state.openApps = state.openApps.map((item)=>{
        if( item.id == menuItem.id )
          item.show()
        else
          item.hide()

        return item
      })
    },

    setItems(state, items)
    {
      state.items = items
    },

    setAppMenuStatus(state, status)
    {
      state.appMenuStatus = status
    },

    toggleAppMenuStatus(state)
    {
      state.appMenuStatus = !state.appMenuStatus
    },

}

const menu = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default menu